import * as React from "react";
import { SceneButtonProps } from "./Sizes";
import "./SceneButtons.scss";

function EditPencil({isChecked, ...otherProps}: SceneButtonProps) {
    return (
        <svg className={"edit-button"} width={40} height={40} fill="none" xmlns="http://www.w3.org/2000/svg" {...otherProps}>
            <path
                className={"outline"}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 37c9.389 0 17-7.611 17-17S29.389 3 20 3 3 10.611 3 20s7.611 17 17 17z"
                fill={isChecked ? "#EB3D00" : "#FFFFFF66"}
                fillOpacity={0.6}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20 30c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10z"
                fill="#fff"
            />
            <path
                className={"pencil"}
                d="M23.53 15.161a.645.645 0 01.428-.161c.159 0 .311.05.434.161l1.43 1.3a.518.518 0 010 .783l-1.119 1.017-2.291-2.083 1.118-1.017zM15 22.917l6.758-6.145 2.291 2.084L17.291 25H15v-2.083z"
                stroke={isChecked ? "#EB3D00" : "#838280"}
            />
        </svg>
    );
}

export default EditPencil;
